import { render } from "./TextUsIcon.vue?vue&type=template&id=38d7c3f8"
import script from "./TextUsIcon.vue?vue&type=script&lang=js"
export * from "./TextUsIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/ChatWidget/ChatIcons/TextUsIcon.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "38d7c3f8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('38d7c3f8', __exports__)) {
    api.reload('38d7c3f8', __exports__)
  }
  
  module.hot.accept("./TextUsIcon.vue?vue&type=template&id=38d7c3f8", () => {
    api.rerender('38d7c3f8', render)
  })

}


export default __exports__